import { createAction, props } from '@ngrx/store';

import { Departamento } from '@rpe/registro-personas-empresas-lib/src/lib/departamentos/departamentos.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityDepartamentosLoadRequest = createAction(
  '[ENTITYDEPARTAMENTOS] Load Request'
);

export const entityDepartamentosLoadFailure = createAction(
  '[ENTITYDEPARTAMENTOS] Load Failure',
  props<{ error: Error }>()
);

export const entityDepartamentosLoadSuccess = createAction(
  '[ENTITYDEPARTAMENTOS] Load Success',
  props<{ items: Departamento[] }>()
);
